<ion-content class="ion-padding">
  <section class="contrato-selecionar-tipo-assinatura">

    <usucampeao-header title="Assinaturas comprovante de renda"></usucampeao-header>

    <div class="contrato-selecionar-tipo-assinatura__content">
      <div class="contrato-selecionar-tipo-assinatura__types ion-margin-bottom">
        <contrato-tipo-assinatura titulo="Fotografia do comprovante físico assinado"
          descricao1="Tire ou faça o upload de uma foto do comprovante físico de comprovante de renda assinado."
          imageUrl="../../../../assets/images/contrato_fisico.svg">

          <ion-button mode="md"
            (click)="verificarSeTipoPorLinkESelecionarTipoAssinatura(cadastroContratoTipoAssinatura.FISICO)">
            Tirar foto do comprovante
          </ion-button>
        </contrato-tipo-assinatura>
      </div>


      <ion-button class="ion-margin-top" mode="md" fill="outline" (click)="voltar()">
        Voltar
      </ion-button>
    </div>
  </section>
</ion-content>